
<template>
  <b-modal
      title="Update Organization Association"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
      @hidden="reset"
    >
    <template #modal-header-close>
      <h4>X</h4>
    </template>
    <b-row>    
      <h2 v-show="updateUserMembershipPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="updateUserMembershipPending" color="#0F347B" size="50px"></pulse-loader>
    </b-row>

    <b-row v-if="!updateUserMembershipPending">
      <b-col>      
        Modifying or removing organizations from Group Membership is not currently a feature.  
        <br>
        <br>
        If you would like to change <b>{{orgName}}</b> association with <b>{{selectedGroup.groupName}}</b> , then please let the system administrator know.
      </b-col>
      <b-col>
        <br>
        <b>Created At: </b>  {{ getCreatedAt() }}
        <div v-if="_.isObject(selectedGroup.createdBy)">
          <b> by: </b> {{ _.get(selectedGroup, 'createdBy.emailAddress', '') }}
        </div>
        <br>
        <b>Last Updated: </b> {{ getLastUpdateDate() }}
        <div v-if="_.isObject(selectedGroup.updatedBy)">
          <b> by: </b> {{ _.get(selectedGroup, 'updatedBy.emailAddress', '') }}
        </div>
        <br>
      </b-col>
    </b-row>

    <b-alert
      dismissible
      fade
      :show="updateUserMembershipFailure || _.isObject(updateUserMembershipSuccess)"
      :variant="updateUserMembershipFailure ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <!-- <b-button
          :visibilut="true"
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-left"
          @click="userMemberHandlerDelete"
      > 
        <span class="button-text">Delete</span>
      </b-button>     -->
      <span class="text-danger"> Please contact the system admin to modify group membership.  </span>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DeleteGroupOrgMembershipModal',
  props: {
    showModal: Boolean,
    orgId: Number,
    orgName: String
  },
  data: function () {
    return {
      updateUserMembershipPending: false,
      updateUserMembershipFailure: false,
      updateUserMembershipSuccess: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      selectedGroup: 'getViewgroup'
    })
  },
  methods: {
    reset: function () {
      this.$emit('update:showModal', false)
    },
    apiResponseMessage () {
    },
    userMemberHandlerDelete () {
    },
    getCreatedAt () {
      const selectedGroup = this.selectedGroup
      if (selectedGroup.createdAt && selectedGroup.createdAt.includes('T')) {
        return this.$utils.formatDate(selectedGroup.createdAt)
      } else if (selectedGroup.createdAt) {
        return this.$utils.unixToHuman(selectedGroup.createdAt / 1000)
      }
    },
    getLastUpdateDate: function () {
      const selectedGroup = this.selectedGroup
      if (selectedGroup.updatedAt && selectedGroup.updatedAt.includes('T')) {
        return this.$utils.formatDate(selectedGroup.updatedAt)
      } else if (selectedGroup.updatedAt) {
        return this.$utils.unixToHuman(selectedGroup.updatedAt / 1000)
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Admin/DeleteGroupOrgMembershipModal.vue